import React from 'react';

const ForwardArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      d="M1 5.24615C0.583661 5.24615 0.246151 5.58366 0.246151 6C0.246151 6.41634 0.583661 6.75385 1 6.75385V5.24615ZM15.5331 6.53305C15.8274 6.23866 15.8274 5.76134 15.5331 5.46695L10.7356 0.669481C10.4412 0.375085 9.96388 0.375085 9.66948 0.669481C9.37508 0.963878 9.37508 1.44119 9.66948 1.73558L13.9339 6L9.66948 10.2644C9.37508 10.5588 9.37508 11.0361 9.66948 11.3305C9.96388 11.6249 10.4412 11.6249 10.7356 11.3305L15.5331 6.53305ZM1 6.75385H15V5.24615H1V6.75385Z"
      fill="white"
    />
  </svg>
);

export default ForwardArrow;
